import React, { useState, useRef } from "react";

const SearchForm = ({ placeholder, loading, onChange }) => {
    const [inputValue, setInputValue] = useState("");
    const debounceRef = useRef(null);
    
    const handleSearch = (event, quickTrigger = false) => {

        const keyword = event.target.value; // Store the input value
        setInputValue(keyword);
        if (event?.target) {
            // Clear previous timeout
            if (debounceRef.current) {
                clearTimeout(debounceRef.current);
            }

            debounceRef.current = setTimeout(() => {
                onChange(keyword);
            }, 1500);
            
        }else{
            onChange(inputValue);
        }
        
    };

    const handleSubmit = (event) => {
        event.preventDefault(); 
        
        onChange(inputValue);
    };

    return (
        <div className="search-area">
            <form onSubmit={handleSubmit}>
                <input
                    type="text"
                    name="search"
                    placeholder={placeholder}
                    onChange={(e) => handleSearch(e)}
                />
                {loading ? (
                    <i
                        className="ri-loader-2-fill"
                        style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                        }}
                    ></i>
                ) : (
                    <i className="ri-search-line"></i>
                )}
            </form>
        </div>
    );
};

export default SearchForm;
